import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate, useLocation, Link } from "react-router-dom";
import styles from './navbar.module.css';
import { useTranslation } from 'react-i18next';

const NavBar = (props) => {
  const {t, i18n} = useTranslation();    
  const navigate = useNavigate();
  const location = useLocation();
  const percentage = props.percentage;
  const vocabularycount = props.vocabularycount;

  const pages = [{ name: t('Lessons'), url: ''} , { name: 'Koleksiyon', url: 'collection'}];
  const pagesxs = [{ name: t('Lessons'), url: ''} , { name: 'Koleksiyon', url: 'collection'}, { name: t('Profile'), url: 'profile'}, { name: 'Settings', url: 'settings'}];
  const settings = [{ name: 'Profile', url: 'profile'}, { name: 'Settings', url: 'settings'}, { name: 'Help', url: 'help'}];

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const avatarurl = props.avatarurl;
  const languagecode = props.languagecode ? props.languagecode : "en";

  return (
    <AppBar position="sticky" style={{backgroundColor: '#EE5E5F'}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
        <Tooltip title="Change language">
        <IconButton 
              onClick={() => navigate("/language", { state: { from: location.pathname } })} 
              sx={{ p: 0 }}
          >
              <Avatar 
                  alt="Change Language" 
                  src={require(`../assets/flags/${languagecode}flag.svg`)}
              />
          </IconButton>
        </Tooltip>

        <Box sx={{ display: { xs: 'flex', lg: 'none' } }}>
          <MenuItem sx={{ ml: 2 }} >
            <img src={require('../assets/icons/vocabularycount.png')} width="40" height="40">
            </img>
            <span className={styles.homemenustats}>{vocabularycount}</span>
            </MenuItem>
            <MenuItem>
            <img src={require('../assets/icons/badgetourist.png')} width="40" height="40">
            </img>
            <span className={styles.homemenustats}>{'%' + percentage}</span>
            </MenuItem>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', lg: 'none' }, justifyContent: 'flex-end' }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', lg: 'none' },
              }}
            >
              {pagesxs.map((page) => (
                <MenuItem key={page.name} component={Link} to={'/' + page.url} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', lg: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                component={Link} to={'/' + page.url}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, mx: 4, color: 'black', display: 'block' }}
              >
                {page.name}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem component={Link} to={'/' + setting.url} key={setting.name} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{setting.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box sx={{ display: { xs: 'none', lg: 'flex' } }}>
            <Tooltip title="Profile">
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar alt="Remy Sharp" src={avatarurl} />
          </IconButton>
        </Tooltip>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default NavBar;
